import { AcceptEdgeCombos, UserSettingsResponse } from '@/hooks/use-auth-user-settings';
import { logger } from '@/utils/logging';

import { PicksValidationProcessor, ValidateResponse } from '.';
import { EdgeComboDialogContext } from '../components/EdgeComboModalProvider';
import { useBetslipStore } from '../hooks/use-betslip-store';
import { PlayerWithTeam } from '../types';
import { getFirstNotAcceptedEdgeCombo, hasNewEdgeCombos } from '../utils/betslip-edge-combos';
import { getInvalidPicksError } from '../utils/betslip-utils';

type Context = {
    userSettings: UserSettingsResponse['data'] | undefined;
    edgeComboDialogContext: EdgeComboDialogContext;
    removeFunction: (picks: { eventId: string; player: PlayerWithTeam }[]) => void;
};

const LOG_TAG = '[Betslip-Edge-Combos]';
export class PicksEdgeComboProcessor extends PicksValidationProcessor<Context> {
    process(data: ValidateResponse): void {
        const acceptedEdgeCombos = useBetslipStore.getState().acceptedEdgeCombos;
        const acceptEdgeCombo = useBetslipStore.getState().actions.acceptEdgeCombo;
        const activeGameMode = useBetslipStore.getState().activeGameMode;

        const result = data.validateEntryOnEntryRules.find(it => it.gameMode === activeGameMode);

        if (!result) {
            logger.warn(LOG_TAG, `No validation result for active ${activeGameMode} game mode found.`);
            return;
        }

        const invalidPicksError = getInvalidPicksError(result);

        if (invalidPicksError) {
            return;
        }

        if (hasNewEdgeCombos(result, acceptedEdgeCombos)) {
            const newEdgeCombo = getFirstNotAcceptedEdgeCombo(result.edgeCombos ?? [], acceptedEdgeCombos);

            const alwaysAcceptEdgeCombos = this.context.userSettings?.accept_edge_combos === AcceptEdgeCombos.ENABLED;

            if (newEdgeCombo) {
                const edgeComboPlayers = useBetslipStore
                    .getState()
                    .betslip.filter(pick => newEdgeCombo.includes(pick.player.id));
                const [player1, player2] = edgeComboPlayers;
                if (alwaysAcceptEdgeCombos) {
                    acceptEdgeCombo(newEdgeCombo);
                } else {
                    this.context.edgeComboDialogContext.showAcceptEdgeComboPairModal({
                        edgeCombo: [player1, player2],
                        removePlayers: this.context.removeFunction,
                        displayMode: 'action',
                        acceptEdgeCombo: () => acceptEdgeCombo(newEdgeCombo),
                    });
                }
            }
        }

        //always proceed to next processor
        this.nextProcessor?.process(data);
    }
}
